var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 0.991699C3.87393 0.991699 0.991699 3.87393 0.991699 7.49996C0.991699 11.126 3.87393 14.0082 7.49996 14.0082C11.126 14.0082 14.0082 11.126 14.0082 7.49996C14.0082 3.87393 11.126 0.991699 7.49996 0.991699ZM10.0103 10.7541L7.49996 8.24377L4.98963 10.7541L4.24583 10.0103L6.75616 7.49996L4.24583 4.98963L4.98963 4.24583L7.49996 6.75616L10.0103 4.24583L10.7541 4.98963L8.24377 7.49996L10.7541 10.0103L10.0103 10.7541Z",
    fill: "#999898"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6d5cfa4b.svg";
export { ForwardRef as ReactComponent };